/* CSS */
import "@js/parts/css";

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR");
    });
}

// App imports
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import 'lazysizes';
import reframe from 'reframe.js';

// Project imports
// Project utils
import env from '@js/utils/env';
import utils from '@js/utils/utils';

// Project helpers
import DelayedCall from '@js/helpers/DelayedCall';
import Calcs from '@js/helpers/Calcs';

// Scrolling modules
import PageScrolling from '@js/modules/PageScrolling';
import PageScrollingManager from '@js/modules/PageScrollingManager';
import Carousel from '@js/modules/Carousel';
import InlineVideo from '@js/modules/InlineVideo.js';
import Modal from '@js/modules/Modal.js';
import Consent from '@js/modules/Consent.js';
import TooltipCursor from '@js/modules/TooltipCursor.js';

// Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(focus);

// Cookie consent. Registered before start() — Alpine.data() is a no-op after.
Alpine.data('cookieConsent', Consent.component);

Alpine.start();


window.APP =
    window.APP ||
    new (function APP() {
        // Utilities
        this.env = env;
        this.utils = utils;

        // Helpers
        this.helpers = {
            DelayedCall: DelayedCall,
            GoToScrollPos: false,
            ModalOpenClass: '_modal-open',
        };

        this.modules = {
            PageScrolling: PageScrolling,
            PageScrollingManager: PageScrollingManager,
        };

        /* Document load */
        document.addEventListener('DOMContentLoaded', () => {
            // Reframe
            reframe('.reframe');

            // Inline video
            new InlineVideo();

            // Tooltip cursor
            new TooltipCursor();

            // Carousels
            Carousel.initAll();

            // Modal
            Modal.init();
        });
    })();
